'use strict'

import OrderStates from "@/translations/states/OrderStates";
import httpClient from "@/services/http.services";
import settings from "@/settings";
import RequestPositionStates from "@/translations/states/RequestPositionStates";
import InvoiceStates from "@/translations/states/InvoiceStates";
import OfferStates from "@/translations/states/OfferStates";
import constants from "@/constants";
import { computeByContext } from '@/utils/pricing';
import formatMixins from "@/mixins/formatMixins";
import calculateMixins from "@/mixins/calculateMixins";
import generateMixins from "@/mixins/generateMixins";
import webSocketMixins from "@/mixins/webSocketMixins";
import showErrorsMixins from "@/mixins/showErrorsMixins";
import overlayVisibilityMixins from "@/mixins/overlayVisibilityMixins";
import billingFeaturesMixins from "@/mixins/billingFeaturesMixins";

const modalWithPositionsMixins = {
    mixins: [
        formatMixins,
        calculateMixins,
        generateMixins,
        webSocketMixins,
        showErrorsMixins,
        overlayVisibilityMixins,
        billingFeaturesMixins
    ],
    props: {
        item: Object,
        visible: Boolean,
        masters: Array,
        responsibles: Array,
        taxes: Array,
        services: Array,
        suppliers: Array,
        areas: Array,
        warehouseItems: Array,
        isSecondModal: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            serviceMetaPosition: null,
            serviceMetaWorkTimeHours: null,
            serviceMetaWorkTimeMinutes: null,
            serviceMetaInvoiceQty: null,
            serviceMetaPendingOpen: null,
            // serviceMetaWorkTimeManual: false,
            // serviceMetaInvoiceQtyManual: false,

            editingPricePosition: null,
            positionPickerModal: false,
            positionMastersModal: false,
            positionMastersPosition: null,

            positionMenusState: {
                activeKey: null,
            },
            skipCustomerDropdownChangeHandlerOnce: false,
            customerSelectionSource: 'customer', //'customer' / 'representative'
            prevSelectedCustomerId: null,
            customerFieldsRequestId: 0,
            vehicleOwnerRequestId: 0,
            representativeSelectionVersion: 0,
            overdueTaxModal: false,
            ignoreOverdueTax: false,
            closedFinancialDataEditingEnabled: false,
            maxTotalTime: 999,
            position: {},
            updatedPositionId: null,
            ignoreSellingPriceIsTooLow: false,
            confirmSellingPriceIsTooLowModal: false,
            showDiscountColumn: false,
            customerCommentMaxChars: 2000,
            internalCommentMaxChars: 1000,
            recommendationMaxChars: 1000,
            offerAdditionalInformationMaxChars: 1000,
            salesInvoiceCommentMaxChars: 500,
            salesInvoiceStaffCommentMaxChars: 500,
            salesInvoiceRecommendationMaxChars: 1000,
            warehouseCategories: null,
            clearCustomerSearchData: false,
            clearCarSearchData: false,
            showCustomerMinCharsMessage: true,
            showCarMinCharsMessage: true,
            generateTaskOrder: true,
            disableSaveButton: false,
            areasData: [],
            suppliersData: [],
            mastersData: [],
            servicesData: [],
            taxesData: [],
            warehouseItemsData: [],
            selectedState: null,
            positionToUpdate: {},
            paymentsToDeleteIds: [],
            itemData: {},
            selectedResponsible: null,
            selectedArea: null,
            submitted: false,
            customer: null,
            customersDataIsLoading: false,
            carModal: false,
            carModalPayload: null,
            carsDataIsLoading: false,
            selectedCar: null,
            carSearchData: null,
            customers: null,
            car: null,
            selectedCustomer: null,
            selectedContactPerson: null,
            customerModalVisible: false,
            customerModalMode: null,  // 'create' | 'edit'
            customerModalTarget: null, // 'customer' | 'representative'
            customerModalPayload: null,
            supplierModal: false,
            supplier: null,
            warehouseItemModal: false,
            warehouseItem: null,
            userCanAddNewWarehouseItem: true,
            confirmPositionDeleteModal: false,
            positionToDelete: null,
            selectedMasters: [],
            updateMasters: false,
            useConsumables: false,
            showCarData: true,
            showDeleted: false,
            consumable: null,
            originalConsumable: null,
            addRecommendations: false,
            positions: [],
            defaultTaxId: null,
            summary: {
                sum: null,
                tax: null,
                grand_total: null,
                totalTime: 0
            },
            settings,
            constants,
            RequestPositionStates,
            InvoiceStates,
            OfferStates: OfferStates.filter(state => state.num !== 5),
            OrderStates: OrderStates.filter(state => state.num <= 8),
            financialPeriodHasBeenClosed: false,
            issuedDateFinancialPeriodHasBeenClosed: false,
            confirmEditClosedFinancialPeriodDataModal: false,
            customerDisabled: false,
            carDisabled: false,
            editingIsDisabled: false,
            positionsEditingIsDisabled: false,
            issuedDateIsDisabled: false,
            paymentDueDateIsDisabled: false,
            penaltyInputIsDisabled: false,
            orderStateDropdownIsDisabled: false,
            orderStartDateIsDisabled: false,
            responsibleDropdownIsDisabled: false,
            selectedMastersDropdownIsDisabled: false,
            modalDataIsLoading: false,
        }
    },
    provide() {
        return {
            positionMenusState: this.positionMenusState,
            openPositionMenu: this.openPositionMenu,
            closePositionMenus: this.closePositionMenus,
        }
    },
    mounted() {
        document.addEventListener(
            'scroll',
            this.handlePositionServiceMetaScroll,
            true
        )
    },

    beforeUnmount() {
        this.customerFieldsRequestId++;
        this.vehicleOwnerRequestId++;
        this.customersDataIsLoading = false;
        document.removeEventListener(
            'scroll',
            this.handlePositionServiceMetaScroll,
            true
        )

        this.hidePositionServiceMetaOverlay()
    },
    watch: {
        'selectedCustomer.id': {
            flush: 'sync',
            handler() {
                this.customerFieldsRequestId++;
                this.vehicleOwnerRequestId++;
                this.customersDataIsLoading = false;
            },
        },
        'selectedCar.id': {
            flush: 'sync',
            handler() {
                this.vehicleOwnerRequestId++;
                this.customersDataIsLoading = false;
            },
        },
        'selectedContactPerson.id': {
            flush: 'sync',
            handler() {
                this.representativeSelectionVersion++;
            },
        },
        areas: {
            immediate: true,
            handler(value) {
                this.areasData = (value || []).map(m => ({
                    id: +m.id || null,
                    name: m.name || null,
                    description: m.description || null,
                }))
            }
        },
        suppliers: {
            immediate: true,
            handler(value) {
                this.suppliersData = (value || []).map(m => ({
                    ...m,
                    id: +m.id || null,
                    days_to_pay: +m.days_to_pay || null,
                    tax_id: +m.tax_id || null,
                }))
            }
        },

        masters: {
            immediate: true,
            handler(value) {
                this.mastersData = (value || []).map(m => ({
                    ...m,
                    id: +m.id || null,
                }))
            }
        },

        services: {
            immediate: true,
            handler(value) {
                this.servicesData = (value || []).map(m => ({ ...m, id: +m.id || null }))
            }
        },

        taxes: {
            immediate: true,
            handler(value) {
                this.taxesData = (value || []).map(m => ({
                    ...m,
                    id: +m.id || null,
                    is_default: +m.is_default || 0,
                    status: +m.status || 0,
                }))
            }
        },

        warehouseItems: {
            immediate: true,
            handler(value) {
                this.warehouseItemsData = (value || []).map(m => ({ ...m, id: +m.id || null }))
            }
        },
        visible: {
            flush: 'sync',
            handler(value) {
                this.customerFieldsRequestId++;
                this.vehicleOwnerRequestId++;
                this.customersDataIsLoading = false;
                if (!value) {
                    this.hidePositionServiceMetaOverlay()

                    this.closedFinancialDataEditingEnabled = false
                    this.updatedPositionId = null
                    this.disableSaveButton = false
                    this.dataIsSending = false
                    this.modalDataIsLoading = false

                    this.itemData = {}
                    this.submitted = false
                    this.selectedArea = null

                    this.selectedCustomer = null
                    this.selectedContactPerson = null

                    this.selectedCar = null

                    this.selectedResponsible = null
                    this.selectedMasters = []
                    this.positions = []
                    this.updateMasters = false
                    this.showDeleted = false
                    this.deletedPositions = false
                    this.paymentsToDeleteIds = []
                    this.customers = null
                    this.customer = null

                    this.carSearchData = null

                    this.companyContactPersons = []
                    this.customerCars = []

                    this.consumable = null
                    this.originalConsumable = null
                    this.useConsumables = false

                    this.selectedState = null
                    this.payments = []
                    this.itemData.orderWasUpdatedByThirdParty = false

                    this.itemData.staff_comment = null
                    this.itemData.customer_comment = null
                    this.itemData.additional_information = null
                    this.itemData.recommendation = null
                    this.itemData.invoice_comment = null

                    this.generateTaskOrder = true

                    this.financialPeriodHasBeenClosed = false
                    this.issuedDateFinancialPeriodHasBeenClosed = false

                    this.customerDisabled = false
                    this.carDisabled = false
                    this.editingIsDisabled = false
                    this.positionsEditingIsDisabled = false
                    this.issuedDateIsDisabled = false
                    this.paymentDueDateIsDisabled = false
                    this.penaltyInputIsDisabled = false
                    this.orderStateDropdownIsDisabled = false
                    this.orderStartDateIsDisabled = false
                    this.responsibleDropdownIsDisabled = false
                    this.selectedMastersDropdownIsDisabled = false

                    this.showDiscountColumn = false
                    this.ignoreSellingPriceIsTooLow = false
                    this.ignoreOverdueTax = false

                    this.editingPricePosition = null
                    this.ignoreSellingPriceIsTooLow = false
                    this.confirmSellingPriceIsTooLowModal = false

                    this.$refs.positionPickerModal?.clearModalData()

                    if (typeof this.clearSortableDragState === 'function') {
                        this.clearSortableDragState()
                    }
                }
            },
        },
        '$store.state.dropdownOverlayVisible'(value) {
            if (!value) {
                this.$refs.selectedMastersDropdown?.hide()

                if (this.serviceMetaPosition) {
                    this.$refs.positionServiceMetaOverlay?.hide()
                }
            }
        },
        '$store.state.secondLayerIsOpened'(value) {
            if (!value) {
                if (this.confirmPositionDeleteModal) {
                    this.closeConfirmPositionDeleteModal()
                }
                if (this.customerModalVisible) {
                    this.closeCustomerModal()
                }
                if (this.carModal) {
                    this.closeCarModal()
                }
                if (this.supplierModal) {
                    this.closeSupplierModal()
                }
                if (this.warehouseItemModal) {
                    this.closeWarehouseItemModal()
                }
                if (this.reduceRequestPositionModal) {
                    this.closeReduceRequestPositionModal()
                }
                if (this.changeRequestQtyModal) {
                    this.closeChangeRequestQtyModal()
                }
                if (this.restorePositionModal) {
                    this.closeConfirmRestorePositionModal()
                }
                if (this.returnCancellationModal) {
                    this.closeReturnCancellationModal()
                }
                if (this.overdueTaxModal) {
                    this.closeOverdueTaxModal()
                }
                if (this.confirmEditClosedFinancialPeriodDataModal) {
                    this.closeConfirmEditClosedFinancialPeriodDataModal()
                }
                if (this.confirmSellingPriceIsTooLowModal) {
                    this.closeConfirmSellingPriceIsTooLowModal()
                }
                if (this.positionMastersPosition ) {
                    this.closePositionMastersModal()
                }
                if (this.positionPickerModal) {
                    this.closePositionPickerModal()
                }
            }
        },
    },
    methods: {
        getDefaultPositionWorkTime(position) {
            if (!position || Number(position.type) !== 1) {
                return null
            }

            const qty = Number(position.qty ?? 0)

            if (!Number.isFinite(qty) || qty <= 0) {
                return 0
            }

            const unitTime = Number(
                position.selectedService?.time ??
                position.service?.time ??
                0
            )

            return Number(
                (
                    unitTime * qty
                ).toFixed(4)
            )
        },

        ensurePositionServiceMeta(position) {
            if (!position || Number(position.type) !== 1) {
                return
            }

            if (
                position.work_time === undefined ||
                position.work_time === null
            ) {
                position.work_time =
                    this.getDefaultPositionWorkTime(position)

                position.work_time_manual = false
            }

            if (
                position.customer_qty === undefined ||
                position.customer_qty === null
            ) {
                position.customer_qty = Number(position.qty ?? 0)
                position.customer_qty_manual = false
            }
        },

        changeServiceWithMeta(position) {
            position.work_time_manual = false
            position.customer_qty_manual = false

            this.changeService(position)

            this.$nextTick(() => {
                position.work_time =
                    this.getDefaultPositionWorkTime(position)

                position.customer_qty =
                    Number(position.qty ?? 0)

                this.updateSummary()
                this.syncOrderEndByWorkingHours?.()
            })
        },

        updatePositionQtyWithMeta(position, value, max, min) {
            this.updatePosition(
                position,
                value,
                'qty',
                max,
                min
            )

            if (Number(position.type) !== 1) {
                return
            }

            if (!position.work_time_manual) {
                position.work_time =
                    this.getDefaultPositionWorkTime({
                        ...position,
                        qty: value,
                    })
            }

            const qty = Number(value ?? 0)

            if (!position.customer_qty_manual) {
                position.customer_qty = qty
            } else {
                const invoiceQtyAbs = Math.max(
                    0.01,
                    Math.abs(Number(position.customer_qty ?? 0))
                )

                position.customer_qty =
                    qty < 0
                        ? -invoiceQtyAbs
                        : invoiceQtyAbs
            }

            if (!position.isNew) {
                this.checkPositionHasBeenUpdated(position)
            }

            this.updateSummary()
        },

        positionHasManualWorkTime(position) {
            if (!position || Number(position.type) !== 1) {
                return false
            }

            if (
                position.work_time_manual !== undefined &&
                position.work_time_manual !== null
            ) {
                return Boolean(Number(position.work_time_manual))
            }

            return (
                position.work_time !== undefined &&
                position.work_time !== null
            )
        },

        positionHasManualInvoiceQty(position) {
            if (!position || Number(position.type) !== 1) {
                return false
            }

            if (
                position.customer_qty_manual !== undefined &&
                position.customer_qty_manual !== null
            ) {
                return Boolean(Number(position.customer_qty_manual))
            }

            return (
                position.customer_qty !== undefined &&
                position.customer_qty !== null
            )
        },

        hasCustomPositionServiceMeta(position) {
            return (
                this.positionHasManualWorkTime(position) ||
                this.positionHasManualInvoiceQty(position)
            )
        },

        setServiceMetaWorkTimeInputs(position) {
            if (!position) {
                this.serviceMetaWorkTimeHours = null
                this.serviceMetaWorkTimeMinutes = null
                this.serviceMetaInvoiceQty = null

                return
            }

            if (this.positionHasManualWorkTime(position)) {
                const totalMinutes = Math.max(
                    0,
                    Math.round(
                        Number(position.work_time ?? 0) * 60
                    )
                )

                this.serviceMetaWorkTimeHours =
                    Math.floor(totalMinutes / 60)

                this.serviceMetaWorkTimeMinutes =
                    totalMinutes % 60
            } else {
                this.serviceMetaWorkTimeHours = null
                this.serviceMetaWorkTimeMinutes = null
            }

            this.serviceMetaInvoiceQty =
                this.positionHasManualInvoiceQty(position)
                    ? Number(position.customer_qty)
                    : null
        },

        openPositionServiceMeta(event, position) {
            if (!position) {
                return
            }

            const overlay =
                this.$refs.positionServiceMetaOverlay

            const target =
                event?.currentTarget ||
                event?.target ||
                null

            // Кликнули повторно на карандаш той же позиции
            if (this.serviceMetaPosition === position) {
                overlay?.hide()
                return
            }

            if (this.serviceMetaPosition) {
                this.serviceMetaPendingOpen = {
                    event,
                    target,
                    position,
                }

                overlay?.hide()
                return
            }

            this.serviceMetaPosition = position
            this.setServiceMetaWorkTimeInputs(position)

            this.$nextTick(() => {
                overlay?.show(event, target)
            })
        },

        clearPositionServiceMeta() {
            this.serviceMetaPosition = null
            this.serviceMetaWorkTimeHours = null
            this.serviceMetaWorkTimeMinutes = null
            this.serviceMetaInvoiceQty = null
        },

        formatPositionDefaultWorkTime(position) {
            const value = Number(
                this.getDefaultPositionWorkTime(position) ?? 0
            )

            return this.formatHoursAndMinutes(value)
        },

        isEmptyServiceMetaValue(value) {
            return (
                value === null ||
                value === undefined ||
                value === ''
            )
        },

        resetPositionServiceMeta() {
            if (!this.serviceMetaPosition) {
                return
            }

            this.serviceMetaWorkTimeHours = null
            this.serviceMetaWorkTimeMinutes = null
            this.serviceMetaInvoiceQty = null
        },

        savePositionServiceMeta() {
            const position = this.serviceMetaPosition

            if (!position) {
                return
            }

            const hoursIsEmpty =
                this.isEmptyServiceMetaValue(
                    this.serviceMetaWorkTimeHours
                )

            const minutesIsEmpty =
                this.isEmptyServiceMetaValue(
                    this.serviceMetaWorkTimeMinutes
                )

            const invoiceQtyIsEmpty =
                this.isEmptyServiceMetaValue(
                    this.serviceMetaInvoiceQty
                )

            const workTimeManual =
                !(hoursIsEmpty && minutesIsEmpty)

            let workTime = null

            if (workTimeManual) {
                const hours = Math.max(
                    0,
                    Number(this.serviceMetaWorkTimeHours ?? 0)
                )

                const minutes = Math.min(
                    59,
                    Math.max(
                        0,
                        Number(this.serviceMetaWorkTimeMinutes ?? 0)
                    )
                )

                workTime = Number(
                    (
                        (hours * 60 + minutes) / 60
                    ).toFixed(4)
                )
            }

            const invoiceQtyManual =
                !invoiceQtyIsEmpty

            let invoiceQty = null

            if (invoiceQtyManual) {
                const value = Math.max(
                    0.01,
                    Math.abs(
                        Number(this.serviceMetaInvoiceQty)
                    )
                )

                invoiceQty =
                    Number(position.qty) < 0
                        ? -value
                        : value
            }

            const currentWorkTimeManual =
                Boolean(position.work_time_manual)

            const currentInvoiceQtyManual =
                Boolean(position.customer_qty_manual)

            const currentWorkTime =
                currentWorkTimeManual
                    ? Number(position.work_time ?? 0)
                    : null

            const currentInvoiceQty =
                currentInvoiceQtyManual
                    ? Number(position.customer_qty ?? 0)
                    : null

            const valuesChanged =
                currentWorkTimeManual !== workTimeManual ||
                currentInvoiceQtyManual !== invoiceQtyManual ||
                (
                    workTimeManual &&
                    Math.abs(
                        currentWorkTime - workTime
                    ) > 0.0001
                ) ||
                (
                    invoiceQtyManual &&
                    Math.abs(
                        currentInvoiceQty - invoiceQty
                    ) > 0.0001
                )

            position.work_time_manual =
                workTimeManual

            position.customer_qty_manual =
                invoiceQtyManual

            position.work_time = workTimeManual ? workTime : this.getDefaultPositionWorkTime(position)

            position.customer_qty = invoiceQtyManual ? invoiceQty : Number(position.qty ?? 0)

            this.checkEmployeePaymentToDelete(position)

            if (!position.isNew && valuesChanged) {
                this.checkPositionHasBeenUpdated(position)
            }

            this.updateSummary()
            this.syncOrderEndByWorkingHours?.()

            this.$refs.positionServiceMetaOverlay?.hide()
        },

        closePositionServiceMeta() {
            // this.toggleDropdownOverlayVisibility(false)
            this.toggleDropdownOverlayVisibility(
                false,
                'position-service-meta'
            )

            const pendingOpen =
                this.serviceMetaPendingOpen

            this.serviceMetaPendingOpen = null

            this.clearPositionServiceMeta()

            if (!pendingOpen || !this.visible) {
                return
            }

            this.$nextTick(() => {
                this.serviceMetaPosition =
                    pendingOpen.position

                this.setServiceMetaWorkTimeInputs(
                    pendingOpen.position
                )

                this.$nextTick(() => {
                    this.$refs.positionServiceMetaOverlay?.show(
                        pendingOpen.event,
                        pendingOpen.target
                    )
                })
            })
        },

        formatPositionWorkTime(position) {
            const value =
                position?.work_time !== undefined &&
                position?.work_time !== null
                    ? Number(position.work_time)
                    : Number(
                        this.getDefaultPositionWorkTime(position) ?? 0
                    )

            return this.formatHoursAndMinutes(value)
        },

        hidePositionServiceMetaOverlay() {
            this.serviceMetaPendingOpen = null

            this.$refs.positionServiceMetaOverlay?.hide()

            this.clearPositionServiceMeta()
        },

        onPositionServiceMetaShow() {
            // this.toggleDropdownOverlayVisibility(true)
            //
            // const overlay =
            //     this.$refs.positionServiceMetaOverlay
            //
            // overlay?.unbindScrollListener?.()

            this.toggleDropdownOverlayVisibility(
                true,
                'position-service-meta'
            )

            const overlay =
                this.$refs.positionServiceMetaOverlay

            overlay?.unbindScrollListener?.()
        },

        // handlePositionServiceMetaScroll(event) {
        //     if (!this.serviceMetaPosition) {
        //         return
        //     }
        //
        //     const overlay =
        //         this.$refs.positionServiceMetaOverlay
        //
        //     const overlayElement =
        //         overlay?.container ||
        //         document.querySelector(
        //             '.position-service-meta-overlay'
        //         )
        //
        //     const eventTarget = event?.target
        //
        //     const eventPath =
        //         typeof event?.composedPath === 'function'
        //             ? event.composedPath()
        //             : []
        //
        //     const scrollInsideOverlay =
        //         overlayElement &&
        //         (
        //             eventPath.includes(overlayElement) ||
        //             (
        //                 eventTarget instanceof Node &&
        //                 overlayElement.contains(eventTarget)
        //             )
        //         )
        //
        //     if (scrollInsideOverlay) {
        //         return
        //     }
        //
        //     this.hidePositionServiceMetaOverlay()
        // },
        handlePositionServiceMetaScroll(event) {
            if (!this.serviceMetaPosition) {
                return
            }

            const overlay =
                this.$refs.positionServiceMetaOverlay

            const overlayElement =
                overlay?.container ||
                document.querySelector(
                    '.position-service-meta-overlay'
                )

            const eventTarget = event?.target

            const eventPath =
                typeof event?.composedPath === 'function'
                    ? event.composedPath()
                    : []

            const scrollInsideOverlay =
                overlayElement &&
                (
                    eventPath.includes(overlayElement) ||
                    (
                        eventTarget instanceof Node &&
                        overlayElement.contains(eventTarget)
                    )
                )

            const focusInsideOverlay =
                overlayElement &&
                document.activeElement instanceof Node &&
                overlayElement.contains(document.activeElement)

            if (scrollInsideOverlay || focusInsideOverlay) {
                return
            }

            this.hidePositionServiceMetaOverlay()
        },

        formatPositionInvoiceQty(position) {
            const value =
                position?.customer_qty !== undefined &&
                position?.customer_qty !== null
                    ? Number(position.customer_qty)
                    : Number(position?.qty ?? 0)

            // if (Number.isInteger(value)) {
            //     return this.formatDecimal(value)
            // }

            return this.formatDecimal(value)
        },
        startPriceEditing(position) {
            this.editingPricePosition = position || null
        },

        stopPriceEditing() {
            this.editingPricePosition = null
        },

        isPriceWarningVisible(position) {
            return this.isPositionSellingPriceLowerThanPurchase(position) &&
                this.editingPricePosition !== position
        },

        hasPositionWithSellingPriceLowerThanPurchase() {
            return (this.positions || []).some(position => {
                return this.isPositionSellingPriceLowerThanPurchase(position)
            })
        },

        addPositionsFromTemplate(template) {
            if (this.canUseWorkTemplates === false) return
            const templatePositions = Array.isArray(template?.positions)
                ? template.positions
                : []

            if (!templatePositions.length) return

            templatePositions
                .filter(templatePosition => Number(templatePosition.status ?? 1) === 1)
                .forEach(templatePosition => {
                    const type = Number(templatePosition.type)

                    if (type === 3 && this.canUseWarehouse === false) {
                        return
                    }

                    if (this.itemData.selectedState?.num === 12 && type === 2) {
                        return
                    }

                    const position = {
                        id: null,
                        type,

                        service_id: templatePosition.service_id || null,
                        supplier_id: templatePosition.supplier_id || null,
                        warehouse_item_id: templatePosition.warehouse_item_id || null,

                        selectedService: templatePosition.service || null,
                        selectedSupplier: templatePosition.supplier || null,
                        selectedWarehouseItem: templatePosition.warehouseItem || null,

                        service: templatePosition.service || null,
                        supplier: templatePosition.supplier || null,
                        warehouseItem: templatePosition.warehouseItem || null,

                        code: templatePosition.code || null,
                        raw_code: templatePosition.raw_code || null,
                        name: templatePosition.name || null,

                        qty: this.toNumber(templatePosition.qty, 1),
                        purchase_price: this.toNumber(templatePosition.purchase_price),
                        sell_price: this.toNumber(templatePosition.sell_price),

                        discount: this.toNumber(templatePosition.discount),

                        purchase_sum: 0,
                        discount_sum: 0,
                        tax_sum: 0,
                        sum: 0,
                        total: 0,

                        status: 1,
                        isNew: true,
                        is_warranty: this.isWarrantyOrder,
                        sorting: this.findPositionsLastSortingValue(),
                    }

                    if (type === 2) {
                        position.state = 1
                    }

                    if (type === 3) {
                        position.is_decimal = templatePosition.warehouseItem?.is_decimal || 0
                    }

                    if (type === 1) {
                        if (this.selectedMasters?.length === 1) {
                            const master = this.selectedMasters[0]

                            position.selectedMaster = master
                            position.master = master
                            position.positionMasters = [
                                {
                                    user_id: +master.id,
                                    master,
                                    share_percent: 100,
                                },
                            ]
                        } else {
                            position.positionMasters = []
                        }
                    }

                    this.pickDefaultTax(position)

                    const templateDiscount = this.toNumber(position.discount)

                    const customerDiscount = this.getCustomerPositionDiscount(type) || 0
                    const finalDiscount = Math.max(templateDiscount, customerDiscount)

                    position.discount = finalDiscount > 0 ? finalDiscount : null

                    if (position.discount) {
                        this.showDiscountColumn = true
                    }

                    this.calculatePositionSummary(position)
                    this.updateMarkup(position)

                    this.positions.push(position)
                })

            this.updateConsumable?.()
            this.updateSummary()
            this.syncOrderEndByWorkingHours?.()
            this.closePositionPickerModal()
        },
        openPositionPickerModal() {
            this.positionPickerModal = true
            this.$store.commit('toggleSecondLayer', true)
        },
        closePositionPickerModal() {
            this.positionPickerModal = false
            this.$store.commit('toggleSecondLayer', false)
        },
        getLocationBoolSetting(key, defaultValue = true) {
            const value = this.$store.getters.locationData?.[key]

            if (value === undefined || value === null || value === '') {
                return defaultValue
            }

            return value === true || Number(value) === 1
        },
        getMasterShortName(master) {
            if (!master) return '';

            const firstName = master.first_name || '';
            const lastName = master.last_name || '';

            if (firstName && lastName) {
                return `${firstName.charAt(0)}. ${lastName}`;
            }

            if (master.full_name) {
                const parts = master.full_name.trim().split(/\s+/);

                if (parts.length >= 2) {
                    return `${parts[0].charAt(0)}. ${parts.slice(1).join(' ')}`;
                }

                return master.full_name;
            }

            return firstName || lastName || '';
        },

        getPositionMastersShortLabel(position) {
            const positionMasters = Array.isArray(position.positionMasters)
                ? position.positionMasters
                : [];

            if (!positionMasters.length) return '';

            return positionMasters
                .map((item) => {
                    const masterName = this.getMasterShortName(item.master);
                    const percent = this.formatSharePercent(item.share_percent);

                    return masterName
                        ? `${masterName} ${percent}%`
                        : `${percent}%`;
                })
                // .join(' · ');
                .join(', ');
        },

        openPositionMastersModal(position) {
            if (!position || position.type !== 1) return;

            this.positionMastersPosition = position;
            this.positionMastersModal = true;
            this.$store.commit('toggleSecondLayer', true);
        },

        closePositionMastersModal() {
            this.positionMastersModal = false;
            this.positionMastersPosition = null;
            this.$store.commit('toggleSecondLayer', false);
        },

        savePositionMasters(rows) {
            if (!this.positionMastersPosition) return;

            this.positionMastersPosition.positionMasters = rows;

            const primary = rows[0] || null;

            this.positionMastersPosition.selectedMaster = primary?.master || null;
            this.positionMastersPosition.master = primary?.master || null;

            this.checkEmployeePaymentToDelete(this.positionMastersPosition);

            if (!this.positionMastersPosition.isNew) {
                this.checkPositionHasBeenUpdated(this.positionMastersPosition);
            }

            this.positionMastersModal = false;
            this.positionMastersPosition = null;
            this.$store.commit('toggleSecondLayer', false);
        },

        getMasterFullName(master) {
            if (!master) return '';

            if (master.full_name) {
                return master.full_name;
            }

            return `${master.first_name || ''} ${master.last_name || ''}`.trim();
        },

        formatSharePercent(value) {
            const num = Number(value);

            if (!Number.isFinite(num)) return '';

            return Number.isInteger(num) ? String(num) : num.toFixed(2);
        },

        getPositionMastersLabel(position) {
            const positionMasters = Array.isArray(position.positionMasters)
                ? position.positionMasters
                : [];

            if (positionMasters.length > 1) {
                return positionMasters
                    .map((item) => {
                        const masterName = this.getMasterFullName(item.master);
                        const percent = this.formatSharePercent(item.share_percent);

                        return masterName
                            ? `${masterName} ${percent}%`
                            : `${percent}%`;
                    })
                    // .join(' · ');
                    .join(', ');
            }

            if (positionMasters.length === 1) {
                const item = positionMasters[0];
                const masterName = this.getMasterFullName(item.master);

                if (masterName) {
                    return `${masterName} ${this.formatSharePercent(item.share_percent)}%`;
                }
            }

            if (position.selectedMaster) {
                return this.getMasterFullName(position.selectedMaster);
            }

            if (position.master) {
                return this.getMasterFullName(position.master);
            }

            return '';
        },

        hasMultiplePositionMasters(position) {
            return Array.isArray(position.positionMasters) && position.positionMasters.length > 1;
        },
        normalizePositionMastersForUi(position, selectedMaster = null) {
            const rows = Array.isArray(position?.positionMasters)
                ? position.positionMasters
                : [];

            if (rows.length) {
                return rows
                    .map((item) => {
                        const userId = +(item.user_id || item.master?.id || 0);

                        if (!userId) return null;

                        const master =
                            item.master ||
                            (+selectedMaster?.id === userId ? selectedMaster : null) ||
                            this.mastersData.find(m => +m.id === userId) ||
                            null;

                        return {
                            id: item.id || null,
                            user_id: userId,
                            master: master
                                ? {
                                    ...master,
                                    id: userId,
                                    full_name: master.full_name || `${master.first_name || ''} ${master.last_name || ''}`.trim(),
                                }
                                : null,
                            share_percent: Number(item.share_percent ?? 0),
                        };
                    })
                    .filter(Boolean);
            }

            if (selectedMaster?.id) {
                return [
                    {
                        user_id: +selectedMaster.id,
                        master: selectedMaster,
                        share_percent: 100,
                    },
                ];
            }

            return [];
        },

        normalizePositionMastersForPayload(position) {
            const rows = Array.isArray(position?.positionMasters)
                ? position.positionMasters
                : [];

            if (rows.length) {
                return rows
                    .map((item) => {
                        const userId = item.user_id || item.master?.id;

                        if (!userId) return null;

                        return {
                            user_id: +userId,
                            share_percent: Number(item.share_percent ?? 0),
                        };
                    })
                    .filter(Boolean);
            }

            if (position?.selectedMaster?.id) {
                return [
                    {
                        user_id: +position.selectedMaster.id,
                        share_percent: 100,
                    },
                ];
            }

            if (position?.master?.id) {
                return [
                    {
                        user_id: +position.master.id,
                        share_percent: 100,
                    },
                ];
            }

            return [];
        },

        getPositionMastersSignature(positionMasters) {
            const rows = Array.isArray(positionMasters) ? positionMasters : [];

            return rows
                .map((item) => {
                    const userId = item.user_id || item.master?.id;
                    const percent = Number(item.share_percent ?? 0);

                    return userId
                        ? {
                            user_id: +userId,
                            share_percent: Math.round(percent * 100) / 100,
                        }
                        : null;
                })
                .filter(Boolean)
                .sort((a, b) => a.user_id - b.user_id)
                .map((item) => `${item.user_id}:${item.share_percent}`)
                .join('|');
        },

        getCustomerPositionDiscount(type) {
            if (!this.selectedCustomer) return null

            const value = type === 1
                ? this.selectedCustomer.services_discount
                : (type === 2 || type === 3 ? this.selectedCustomer.products_discount : null)

            const discount = Number(String(value ?? '').replace(',', '.'))

            return Number.isFinite(discount) && discount > 0 ? discount : null
        },

        applyCustomerDiscountToPosition(position) {
            if (!position) return

            const discount = this.getCustomerPositionDiscount(position.type)

            if (discount) {
                position.discount = discount
                this.showDiscountColumn = true
            }
        },
        openPositionMenu(key) {
            this.positionMenusState.activeKey = key
        },

        closePositionMenus() {
            this.positionMenusState.activeKey = null
        },

        async onCustomerDropdownChange() {
            if (this.skipCustomerDropdownChangeHandlerOnce) {
                this.skipCustomerDropdownChangeHandlerOnce = false;
                return;
            }

            const requestId = ++this.customerFieldsRequestId;
            const customerId = this.selectedCustomer?.id ? +this.selectedCustomer.id : null;
            const isCurrent = () => this.visible && requestId === this.customerFieldsRequestId
                && customerId === (this.selectedCustomer?.id ? +this.selectedCustomer.id : null);
            const previousRepresentative = this.selectedContactPerson ? { ...this.selectedContactPerson } : null;
            const previousRepresentativeId = previousRepresentative?.id ? +previousRepresentative.id : null;
            const customerWasChanged = customerId !== this.prevSelectedCustomerId;

            await this.$nextTick();
            if (!isCurrent()) return;

            const isCompany = +this.selectedCustomer?.type === constants.userTypes.legal_entity;
            if (customerWasChanged || !customerId) {
                this.selectedContactPerson = null;
                this.$refs.contactPersonDropdown?.reset({ clearModel: true, silent: true });
            }
            const representativeVersion = this.representativeSelectionVersion;
            this.prevSelectedCustomerId = customerId;

            if (customerId) {
                await this.$refs.vehicleDropdown?.getCustomerVehicles?.(customerId);
                if (!isCurrent()) return;

                // A manual representative selection takes precedence over auto-fill.
                if (representativeVersion === this.representativeSelectionVersion) {
                    if (isCompany) {
                        await this.$refs.contactPersonDropdown?.getContactPersons?.({
                            preserveSelected: !customerWasChanged && !!previousRepresentativeId,
                            preserveUnlistedSelected: true,
                            autoSelectPrimary: true,
                            preferredRepresentativeId: !customerWasChanged ? previousRepresentativeId : null,
                        });
                        if (!isCurrent()) return;

                    } else {
                        this.selectedContactPerson = null;
                        this.$refs.contactPersonDropdown?.reset({ clearModel: true, silent: true });
                    }
                }
            }

            if (this.isOrderModal) this.updateRemindAppointmentState(true);
        },

        async updateReminderAfterCustomerSaved() {
            if (!this.isOrderModal) return;

            await this.$nextTick();

            this.updateRemindAppointmentState(true);
        },


        saveItemWithoutOverdueTaxCheck() {
            this.closeOverdueTaxModal()
            this.ignoreOverdueTax = true
            this.saveItem()
        },
        openOverdueTaxModal() {
            this.overdueTaxModal = true
            this.$store.commit('toggleSecondLayer', true)
        },
        closeOverdueTaxModal() {
            this.overdueTaxModal = false
            this.$store.commit('toggleSecondLayer', false)
        },

        checkThereIsPositionWithOverdueTax() {
            const now = Date.now()

            // consumable
            const cUntil = this.consumable?.selectedTax?.valid_until
            if (cUntil && now > cUntil * 1000) {
                this.openOverdueTaxModal()
                return true
            }

            const hasOverdue = (this.positions || []).some(p => {
                if (Number(p.status) !== 1) return false

                const until = p?.selectedTax?.valid_until
                return !!until && now > until * 1000
            })

            if (hasOverdue) {
                this.openOverdueTaxModal()
                return true
            }

            return false
        },
        setNewSorting() {
            let sorting = 1
            this.positions.forEach(p => {
                p.sorting = sorting++
                this.checkPositionHasBeenUpdated(p)
            })
        },
        checkPositionHasBeenUpdated(position) {
            if (!position) return

            const originalDiscount =
                position.originalDiscount ? +position.originalDiscount : 0

            const discount =
                position.discount ? +position.discount : 0

            const originalPurchasePrice =
                position.originalPurchasePrice
                    ? +position.originalPurchasePrice
                    : 0

            const purchasePrice =
                position.purchase_price ? +position.purchase_price : 0

            const originalSellPrice =
                position.originalSellPrice ? +position.originalSellPrice : 0

            const sellPrice =
                position.sell_price ? +position.sell_price : 0

            const originalTaxValue =
                position.originalTaxValue ? +position.originalTaxValue : 0

            const taxValue =
                position.tax_value ? +position.tax_value : 0

            const toNum = value => {
                return Number(
                    String(value ?? 0).replace(',', '.')
                ) || 0
            }

            const toNullableNum = value => {
                if (
                    value === null ||
                    value === undefined ||
                    value === ''
                ) {
                    return null
                }

                const number = Number(
                    String(value).replace(',', '.')
                )

                return Number.isFinite(number)
                    ? number
                    : null
            }

            const nullableNumbersDiffer = (first, second) => {
                if (first === null || second === null) {
                    return first !== second
                }

                return Math.abs(first - second) > 0.0001
            }

            const originalQty = toNum(position.originalQty)
            const qty = toNum(position.qty)

            const originalWorkTime =
                toNullableNum(position.originalWorkTime)

            const workTime =
                position.work_time_manual
                    ? toNullableNum(position.work_time)
                    : null

            const originalInvoiceQty =
                toNullableNum(position.originalInvoiceQty)

            const invoiceQty =
                position.customer_qty_manual
                    ? toNullableNum(position.customer_qty)
                    : null

            position.isUpdated = (
                !position.isNew &&
                (
                    position.originalPositionMastersSignature !==
                    this.getPositionMastersSignature(position.positionMasters) ||

                    position.originalSupplierId !== position.supplier_id ||
                    position.originalServiceId !== position.service_id ||
                    position.originalWarehouseItemId !== position.warehouse_item_id ||
                    position.originalCode !== position.code ||
                    position.originalName !== position.name ||

                    originalQty !== qty ||

                    nullableNumbersDiffer(
                        originalWorkTime,
                        workTime
                    ) ||

                    nullableNumbersDiffer(
                        originalInvoiceQty,
                        invoiceQty
                    ) ||

                    originalPurchasePrice !== purchasePrice ||
                    originalSellPrice !== sellPrice ||
                    originalDiscount !== discount ||
                    originalTaxValue !== taxValue ||
                    position.originalStatus !== position.status ||
                    position.originalIsWarranty !== position.is_warranty ||
                    position.originalAccountingCode !== position.accounting_code ||
                    position.originalSorting !== position.sorting
                )
            )
        },
        toggleChangePositionStatus(position) {
            if (!position) return
            position.status = position.status === 0 ? 1 : 0
            position.isRestored = position.originalStatus === 0 && position.status === 1
            position.showDeleted = position.originalStatus === 1 && position.status === 0
            position.forDeletion = position.originalStatus === 1 && position.status === 0

            if (position.status === 0) position.is_warranty = 0

            // if (position.type === 1) {
            //     this.updateConsumable()
            //     this.syncOrderEndByWorkingHours?.()
            //     if (position.status === 0 || !this.selectedMasters || this.selectedMasters.length < 1) {
            //         position.selectedMaster = null
            //     } else if (this.selectedMasters?.length === 1) {
            //         position.selectedMaster = this.selectedMasters[0]
            //     }
            // }

            if (position.type === 1) {
                this.updateConsumable()
                this.syncOrderEndByWorkingHours?.()

                if (position.status === 0 || !this.selectedMasters || this.selectedMasters.length < 1) {
                    position.selectedMaster = null
                    position.master = null
                    position.positionMasters = []
                } else if (this.selectedMasters?.length === 1) {
                    const master = this.selectedMasters[0]

                    position.selectedMaster = master
                    position.master = master
                    position.positionMasters = [
                        {
                            user_id: +master.id,
                            master,
                            share_percent: 100,
                        },
                    ]
                }
            }
            this.checkPositionHasBeenUpdated(position)
            this.updateSummary()
            if (position.type === 1)  this.syncOrderEndByWorkingHours?.()
        },
        toggleShowDeleted() {
            this.showDeleted = !this.showDeleted
            let positionsWithDiscount = null
            let positionsWithWarranty = null
            if (this.showDeleted) {
                positionsWithDiscount = this.positions?.find(p => p.discount && +p.discount)
                positionsWithWarranty = this.positions?.find(p => p.is_warranty)
            } else {
                positionsWithDiscount = this.positions?.find(p => p.discount && +p.discount && p.status)
                positionsWithWarranty = this.positions?.find(p => p.is_warranty && p.status)
            }
            this.showDiscountColumn = !!positionsWithDiscount
            this.isWarrantyOrder = !!positionsWithWarranty
        },
        saveItemAnyway() {
            this.ignoreSellingPriceIsTooLow = true
            this.closeConfirmSellingPriceIsTooLowModal()
            this.saveItem()
        },
        // calculatePositionMarkup(position) {
        //     const markup = ((position.sum * 100) / position.purchase_sum) - 100;
        //     if (isFinite(markup)) {
        //         return this.formatDecimal(markup, false, 2);
        //     } else {
        //         return 0;
        //     }
        // },
        calculatePositionMarkup(position) {
            const purchasePrice = this.toNumber(position.purchase_price)
            const sellPrice = this.toNumber(position.sell_price)
            const discount = this.toNumber(position.discount)

            if (purchasePrice <= 0) {
                return 0
            }

            const actualSellPrice = sellPrice * (1 - discount / 100)
            let markup = ((actualSellPrice * 100) / purchasePrice) - 100

            // Не показываем -0 из-за погрешности JavaScript
            if (Math.abs(markup) < 0.005) {
                markup = 0
            }

            return this.formatDecimal(markup, false, 2)
        },

        disableClosedFinancialPeriodDataEditing() {
            this.customerDisabled = true
            this.carDisabled = true

            this.closedFinancialDataEditingEnabled = false

            this.issuedDateIsDisabled = true

            this.paymentDueDateIsDisabled = true
            this.penaltyInputIsDisabled = true
            this.exportInvoiceCodeInputIsDisabled = true
            this.disableDeletePaymentButtons = true
        },
        disableArchivedOrderDataEditing() {
            if (this.$store.getters.isAccountantOrHigher) return false

            this.customerDisabled = true
            this.carDisabled = true
            this.editingIsDisabled = true
            this.positionsEditingIsDisabled = true
            this.issuedDateIsDisabled = true
            this.paymentDueDateIsDisabled = true
            this.penaltyInputIsDisabled = true
            this.exportInvoiceCodeInputIsDisabled = true

            this.orderStateDropdownIsDisabled = true
            this.selectedMastersDropdownIsDisabled = false
        },
        openConfirmEditClosedFinancialPeriodDataModal() {
            this.confirmEditClosedFinancialPeriodDataModal = true
            this.$store.commit('toggleSecondLayer', true)
        },
        closeConfirmEditClosedFinancialPeriodDataModal() {
            this.confirmEditClosedFinancialPeriodDataModal = false
            this.$store.commit('toggleSecondLayer', false)

        },
        openConfirmSellingPriceIsTooLowModal() {
            this.confirmSellingPriceIsTooLowModal = true
            this.$store.commit('toggleSecondLayer', true)
        },
        closeConfirmSellingPriceIsTooLowModal() {
            this.confirmSellingPriceIsTooLowModal = false
            this.$store.commit('toggleSecondLayer', false)

        },
        editClosedFinancialPeriodDataModal() {
            this.closeConfirmEditClosedFinancialPeriodDataModal()
            this.saveItem()
        },
        generateNewPositionsData() {
            const positions = this.positions?.filter(position => position.isNew)
            if (!positions?.length) return null

            const newPosition = this.generatePositionsData(positions)
            return newPosition
        },
        generateUpdatedPositionsData() {
            const positions = this.positions?.filter(position => position.isUpdated)
            if (!positions?.length) return null

            const updatedPosition = this.generatePositionsData(positions)
            return updatedPosition
        },

        generatePositionsData(positions) {
            return positions.map(position => {
                const isService = Number(position.type) === 1

                const sourceCode = isService && position.isNew
                    ? (position.code ?? position.selectedService?.code)
                    : position.code

                const code = sourceCode === null || sourceCode === undefined
                    ? null
                    : String(sourceCode).trim() || null

                const rawCode = position.raw_code ?? (
                    isService && position.isNew && code
                        ? this.generateRawCode(code)
                        : null
                )

                return {
                    id: position.id,
                    type: position.type,
                    master_id: position.master_id,

                    positionMasters: isService
                        ? this.normalizePositionMastersForPayload(position)
                        : null,

                    supplier_id: position.supplier_id,
                    service_id: position.service_id,
                    warehouse_item_id: position.warehouse_item_id,

                    // accounting_code: (this.exportInvoiceToAccounting ?? this.exportInvoiceToSmartAccounts) && position.accounting_code
                    //     ? position.accounting_code
                    //     : null,
                    accounting_code: position.accounting_code ?? null,

                    code,
                    raw_code: rawCode,

                    name: position.name ? position.name.trim() : null,
                    qty: position.qty,

                    work_time:
                        isService && position.work_time_manual
                            ? Number(position.work_time ?? 0)
                            : null,

                    customer_qty:
                        isService && position.customer_qty_manual
                            ? Number(position.customer_qty ?? position.qty ?? 0)
                            : null,

                    purchase_price: position.purchase_price,
                    purchase_sum: position.purchase_sum,
                    sell_price: position.sell_price,
                    discount: position.discount,
                    discount_sum: position.discount_sum,
                    tax_id: position.tax_id,
                    tax_value: position.tax_value,
                    tax_sum: position.tax_sum,
                    sum: position.sum,
                    total: position.total,
                    status: position.status,
                    state: position.state,
                    sorting: position.sorting,
                    is_warranty: position.is_warranty,
                    created_at: position.created_at,
                    created_by: position.created_by,
                }
            })
        },

        constructConsumable(value) {
            if (!value) return

            this.originalConsumable = null

            const hasSavedConsumable = !!(value.use_consumables && value.consumable)

            if (this.canUseConsumables === false && !hasSavedConsumable) {
                this.useConsumables = false
                this.consumable = null
                return
            }

            if (value.use_consumables) {
                this.useConsumables = true
                if (value.consumable) {
                    const consumableData = {...value.consumable}
                    if (consumableData.discount && +consumableData.discount !== 0) {
                        this.showDiscountColumn = true
                    }
                    const selectedTax = this.itemData.id || value.order_id ? this.findSelectedTax(consumableData) : this.pickDefaultTax(consumableData)
                    if (selectedTax && +selectedTax.value !== +consumableData.tax?.value) {
                        this.calculatePositionSummary(consumableData)
                    }
                    this.consumable = {
                        ...consumableData,
                        qty: consumableData.qty ? +consumableData.qty : 0,
                        sell_price: this.formatDecimal(consumableData.sell_price, false),
                        discount: consumableData.discount && +consumableData.discount !== 0 ? +consumableData.discount : null,
                        discount_sum: consumableData.discount_sum ? +consumableData.discount_sum : 0,
                        selectedTax: selectedTax,
                        tax_value: selectedTax?.value ? +selectedTax.value : 0,
                        tax_sum: consumableData.tax_sum ? +consumableData.tax_sum : 0,
                        sum: consumableData.sum ? +consumableData.sum : 0,
                        total: consumableData.total ? +consumableData.total : 0,
                    }

                    this.originalConsumable = { ...this.consumable }
                } else {
                    this.consumable = null
                }
            } else {
                if (!value.id && !value.offerId && !value.orderId) {
                    this.useConsumables = true
                } else {
                    this.useConsumables = false
                }
                this.consumable = null
            }
        },
        updateItems(id = null) {
            this.$emit('update-items', id)
        },
        findSelectedWarehouseItem(position) {
            if (!position.warehouseItem?.id) return false
            const warehouseItem = this.warehouseItemsData.find(item => +item.id === +position.warehouseItem.id)
            if (warehouseItem) {
                return warehouseItem
            } else {
                if (position.status) {
                    this.warehouseItemsData.push(position.warehouseItem)
                }
                return position.warehouseItem
            }
        },
        findSelectedService(position) {
            if (!position.service?.id) return false
            const service = this.servicesData.find(service => +service.id === +position.service.id)
            if (service) {
                return service
            } else {
                if (position.status) {
                    this.servicesData.push(position.service)
                }
                return position.service
            }
        },
        findSelectedSupplier(position) {
            if (!position.supplier?.id) return false

            const supplier = this.suppliersData.find(supplier => +supplier.id === +position.supplier.id)
            if (supplier) {
                return supplier
            } else {
                if (position.status) {
                    this.suppliersData.push(position.supplier)
                }
                return position.supplier
            }
        },
        // findSelectedMaster(position) {
        //     if (!position.master?.id) {
        //         return false
        //     }
        //     const fullName = position.master.last_name ? (position.master.first_name || '') + ' ' + (position.master.last_name || '') : position.master.first_name || ''
        //     const masterData = { id: position.master.id, full_name: fullName }
        //     return masterData
        // },
        findSelectedMaster(position) {
            if (!position || +position.type !== 1) {
                return false;
            }

            const positionMaster = Array.isArray(position.positionMasters)
                ? position.positionMasters.find(item => +(item.user_id || item.master?.id || 0) > 0)
                : null;

            const userId = +(
                positionMaster?.user_id ||
                positionMaster?.master?.id ||
                position.master?.id ||
                0
            );

            if (!userId) {
                return false;
            }

            const master =
                positionMaster?.master ||
                position.master ||
                this.mastersData.find(item => +item.id === userId) ||
                null;

            if (!master) {
                return false;
            }

            const fullName = master.full_name ||
                `${master.first_name || ''} ${master.last_name || ''}`.trim();

            return {
                ...master,
                id: userId,
                full_name: fullName,
            };
        },
        findSelectedTax(position) {
            if (!position.tax?.id) {
                return false
            }
            const taxInArray = this.taxesData?.find(tax => +tax.id === +position.tax.id || +tax.id === +position.tax_id)

            if (taxInArray) {
                return taxInArray
            } else {
                this.taxesData.push(position.tax)
                return position.tax
            }
        },
        pickDefaultTax(position) {
            if (!position) return

            const taxesDataLength = this.taxesData?.length
            let defaultTax = null

            const tenantCompanyDefaultTaxId = this.$store.getters.locationData?.default_tax_id ?
                +this.$store.getters.locationData.default_tax_id :
                null

            if (taxesDataLength === 1) {
                defaultTax = this.taxesData[0]
            } else if (tenantCompanyDefaultTaxId && taxesDataLength > 1) {
                defaultTax = this.taxesData.find(tax => +tax.id === tenantCompanyDefaultTaxId)
            }

            if (defaultTax) {
                position.selectedTax = defaultTax
                position.tax_id = defaultTax.id
                position.tax_value = defaultTax.value ? +defaultTax.value : 0
            }

            return defaultTax
        },
        // toggleRecommendationHistoryOverlay(event, id) {
        //     if (!event || !id) {
        //         return false
        //     }
        //     this.$refs['mrh' + id.toString()]?.toggle(event);
        // },
        // toggleCustomerCommentsHistoryOverlay(event, id) {
        //     if (!event || !id) {
        //         return false
        //     }
        //     this.$refs['mch' + id.toString()]?.toggle(event);
        // },
        // toggleStaffCommentsHistoryOverlay(event, id) {
        //     if (!event || !id) {
        //         return false
        //     }
        //     this.$refs['msh' + id.toString()]?.toggle(event);
        // },
        updateCustomer(user) {
            if (!user) return false
            this.selectedCustomer = { ...user }
            const customerInList = this.customers?.find(c => c.id === user.id)
            if (user.isNew || !customerInList) {
                if (!this.selectedCar) {
                    this.selectedCar = null
                }
                if (!this.customers?.length) {
                    this.customers = [{...user}]
                } else {
                    this.customers.push({...user})
                }
            } else {
                const indexOfFoundCustomer = this.customers.indexOf(customerInList)
                this.customers[indexOfFoundCustomer] = this.selectedCustomer
            }

            if (!user.isNew) this.updateItem()
            this.changeCustomer()
        },
        openCarModal(payload = null) {
            this.carModal = true;             // 'create' | 'edit'
            this.carModalPayload = payload ?? {};
            this.$store.commit('toggleSecondLayer', true);
        },
        openCustomerModal(target, payload = null) {
            this.customerModalTarget = target;         // 'customer' | 'representative'
            this.customerModalPayload = payload ?? {};
            this.$store.commit('toggleSecondLayer', true);
            this.customerModalVisible = true;
        },

        async changeRepresentative() {
            if (this.isOrderModal) {
                this.updateRemindAppointmentState(true);
            }
        },

        async onCustomerSaved(payload) {
            if (!payload) return;

            if (this.customerModalTarget === 'customer') {
                const previousCustomerId = this.selectedCustomer?.id ? +this.selectedCustomer.id : null;
                const previousContactPerson = this.selectedContactPerson ? { ...this.selectedContactPerson } : null;

                if (payload.mode === 'individual' && payload.customer) {
                    this.selectedCustomer = { ...payload.customer };

                    await this.$nextTick();

                    this.skipCustomerDropdownChangeHandlerOnce = true;
                    this.$refs.customerDropdown?.updateCustomer(payload.customer, { forceSelect: true });

                    await this.$nextTick();

                    const newCustomerId = this.selectedCustomer?.id ? +this.selectedCustomer.id : null;
                    const customerWasChanged = previousCustomerId !== newCustomerId;

                    if (customerWasChanged) {
                        this.selectedContactPerson = null;
                        this.$refs.contactPersonDropdown?.reset({ clearModel: true, silent: true });
                    } else if (previousContactPerson) {
                        this.selectedContactPerson = previousContactPerson;
                        this.$refs.contactPersonDropdown?.updateCustomer(previousContactPerson, { forceSelect: true });
                    }

                    this.prevSelectedCustomerId = newCustomerId;

                    await this.updateReminderAfterCustomerSaved();

                    const isSameCustomer =
                        this.itemData.initialCustomerId &&
                        this.selectedCustomer &&
                        +this.itemData.initialCustomerId === +this.selectedCustomer.id;

                    if (!payload.isNew && isSameCustomer) this.updateItem();

                    return;
                }

                if (payload.mode === 'company' && payload.customer) {
                    this.selectedCustomer = { ...payload.customer };

                    await this.$nextTick();

                    this.skipCustomerDropdownChangeHandlerOnce = true;
                    this.$refs.customerDropdown?.updateCustomer(payload.customer, { forceSelect: true });

                    await this.$nextTick();

                    const newCustomerId = this.selectedCustomer?.id ? +this.selectedCustomer.id : null;
                    const customerWasChanged = previousCustomerId !== newCustomerId;

                    if (payload.representative) {
                        this.selectedContactPerson = { ...payload.representative };

                        this.$refs.contactPersonDropdown?.setCompanyContactPersons?.(
                            [payload.representative],
                            payload.representative
                        );

                        await this.$nextTick();

                        this.$refs.contactPersonDropdown?.updateCustomer(payload.representative, { forceSelect: true });
                    } else if (customerWasChanged) {
                        this.selectedContactPerson = null;
                        this.$refs.contactPersonDropdown?.reset({ clearModel: true, silent: true });
                    } else if (previousContactPerson) {
                        this.selectedContactPerson = previousContactPerson;
                        this.$refs.contactPersonDropdown?.updateCustomer(previousContactPerson, { forceSelect: true });
                    }

                    this.prevSelectedCustomerId = newCustomerId;

                    await this.updateReminderAfterCustomerSaved();

                    const isSameCustomer =
                        this.itemData.initialCustomerId &&
                        this.selectedCustomer &&
                        +this.itemData.initialCustomerId === +this.selectedCustomer.id;

                    if (!payload.isNew && isSameCustomer) this.updateItem();

                    return;
                }

                this.$emit('update-items');
                return;
            }

            if (this.customerModalTarget === 'representative') {
                if (payload.mode === 'individual' && payload.customer) {
                    this.selectedContactPerson = { ...payload.customer };

                    await this.$nextTick();

                    this.$refs.contactPersonDropdown?.updateCustomer(payload.customer, { forceSelect: true });

                    await this.$nextTick();

                    const isSameContactPerson =
                        this.itemData.initialContactPersonId &&
                        this.selectedContactPerson &&
                        +this.itemData.initialContactPersonId === +this.selectedContactPerson.id;

                    if (!payload.isNew && isSameContactPerson) this.updateItem();

                    this.changeRepresentative();
                }
            }
        },

        async changeCustomer(
            getVehicles = true,
            getContactPersons = true,
            preserveContactPerson = false,
            autoSelectPrimaryContact = null,
            autoSelectSingleVehicle = true
        ) {
            const requestId = ++this.customerFieldsRequestId;
            const customerId = this.selectedCustomer?.id ? +this.selectedCustomer.id : null;
            const isCurrent = () => this.visible && requestId === this.customerFieldsRequestId
                && customerId === (this.selectedCustomer?.id ? +this.selectedCustomer.id : null);
            await this.$nextTick();
            if (!isCurrent()) return;

            if (autoSelectPrimaryContact === null) {
                const isEdit = !!(this.item?.id || this.itemData?.id);
                const hadInitialContactPerson = !!(this.itemData?.contact_person_id || this.itemData?.initialContactPersonId);

                autoSelectPrimaryContact = !isEdit || hadInitialContactPerson;
            }

            const prevCustomerId = this.prevSelectedCustomerId;
            const customerChanged = customerId !== prevCustomerId;

            if (!preserveContactPerson && customerChanged && this.selectedContactPerson?.id) {
                this.selectedContactPerson = null;
                this.$refs.contactPersonDropdown?.reset({ clearModel: true, silent: true });
            }

            if (this.selectedContactPerson?.id && customerId && +this.selectedContactPerson.id === customerId) {
                this.selectedContactPerson = null;
                this.$refs.contactPersonDropdown?.reset({ clearModel: true, silent: true });
            }

            this.prevSelectedCustomerId = customerId;

            this.carSearchData = null;
            this.clearCarSearchData = true;

            const representativeVersion = this.representativeSelectionVersion;
            await this.$nextTick();
            if (!isCurrent()) return;

            if (getVehicles) {
                await this.$refs.vehicleDropdown?.getCustomerVehicles?.(customerId, {
                    autoSelectSingle: autoSelectSingleVehicle,
                });
                if (!isCurrent()) return;
            }

            const fromRepresentativeFlow = this.customerSelectionSource === 'representative';

            if (getContactPersons && !fromRepresentativeFlow
                && representativeVersion === this.representativeSelectionVersion) {
                await this.$refs.contactPersonDropdown?.getContactPersons?.({
                    preserveSelected: preserveContactPerson,
                    autoSelectPrimary: autoSelectPrimaryContact,
                });
            }
        },

        closeCustomerModal() {
            this.customerModalVisible = false
            this.customer = {}
            this.$store.commit('toggleSecondLayer', false)
        },

        closeCarModal() {
            this.carModalPayload = {}
            this.carModal = false
            this.$store.commit('toggleSecondLayer', false)
        },
        updateCar(car) {
            if (!car) return false;

            this.selectedCar = { ...car };

            this.$refs.vehicleDropdown?.updateVehicle(car, { forceSelect: true });

            const list = Array.isArray(this.customerCars) ? [...this.customerCars] : [];
            const idx = list.findIndex(v => v.id === car.id);
            if (idx === -1) list.push({ ...car });
            else list[idx] = { ...car };
            this.customerCars = list;


            const isSameCar = this.selectedCar && this.itemData.initialCarId && +this.selectedCar.id === +this.itemData.initialCarId
            if (!car.isNew && isSameCar) this.updateItem()

            this.changeVehicle()
        },

        async changeVehicle() {
            let requestId = ++this.vehicleOwnerRequestId;
            this.customersDataIsLoading = false;
            if (!this.visible || !this.$store.getters.userCanGetData) return;

            const carId = this.selectedCar?.id;
            let expectedCustomerId = this.selectedCustomer?.id ?? null;
            const isCurrent = () => this.visible && requestId === this.vehicleOwnerRequestId
                && carId === this.selectedCar?.id
                && expectedCustomerId === (this.selectedCustomer?.id ?? null);

            if (!this.selectedCar) {
                this.carSearchData = null;
                return false;
            }
            if (this.selectedCustomer || !carId) return false;

            try {
                this.customersDataIsLoading = true;
                const { status, data } = await httpClient.post(
                    'user/get-by-vehicle-id?expand=customerStatus',
                    { carId }
                );
                if (!isCurrent()) return;

                if (status === 200 && data) {
                    this.customerChangedFromVehicle = true;
                    this.customerSearchData = null;
                    this.clearCustomerSearchData = true;

                    expectedCustomerId = data.id ?? null;
                    this.selectedCustomer = data;
                    // The synchronous customer watcher also invalidates the old context.
                    requestId = this.vehicleOwnerRequestId;
                    this.$refs.customerDropdown?.updateCustomer(data, {
                        forceSelect: true,
                        silent: true,
                    });

                    const representativeVersion = this.representativeSelectionVersion;
                    await this.$nextTick();
                    if (!isCurrent() || representativeVersion !== this.representativeSelectionVersion) return;

                    this.selectedContactPerson = null;
                    this.$refs.contactPersonDropdown?.reset({ clearModel: true, silent: true });
                    await this.$refs.contactPersonDropdown?.getContactPersons?.({
                        preserveSelected: false,
                        autoSelectPrimary: true,
                    });
                    // The dropdown updates the selection through v-model itself.
                }
            } catch (err) {
                if (isCurrent()) this.showError(err);
            } finally {
                if (isCurrent()) this.customersDataIsLoading = false;
            }
        },

        async searchWarehouseItems(event, position) {
            if (this.canUseWarehouse === false) {
                if (position) position.warehouseItemsData = []
                return
            }

            if (!this.$store.getters.userCanGetData || !position) return

            const search = String(event?.value ?? '').trim()

            if (!search) {
                position.warehouseItemsData = this.warehouseItemsData
                return
            }

            try {
                const { status, data } = await httpClient(
                    'warehouse/get-dropdown-items?search=' + encodeURIComponent(search)
                )

                if (status === 200 && data?.success) {
                    position.warehouseItemsData = Array.isArray(data.items) ? data.items : []
                } else {
                    position.warehouseItemsData = []
                }
            } catch(err) {
                position.warehouseItemsData = []
                this.showError(err)
            }
        },

        async searchSuppliers(event, position) {
            if (!this.$store.getters.userCanGetData || !position) return

            const search = String(event?.value ?? '').trim()

            if (!search) {
                position.suppliersData = this.suppliersData
                return
            }

            try {
                const { status, data } = await httpClient(
                    'supplier/get-suppliers?search=' + encodeURIComponent(search)
                )

                if (status === 200 && data?.success) {
                    position.suppliersData = Array.isArray(data.items) ? data.items : []
                } else {
                    position.suppliersData = []
                }
            } catch(err) {
                position.suppliersData = []
                this.showError(err)
            }
        },

        async searchServices(event, position) {
            if (!this.$store.getters.userCanGetData || !position) return

            const search = String(event?.value ?? '').trim()

            if (!search) {
                position.servicesData = this.servicesData
                return
            }

            try {
                const { status, data } = await httpClient(
                    'service/get-services?search=' + encodeURIComponent(search)
                )

                if (status === 200 && data?.success) {
                    position.servicesData = Array.isArray(data.items) ? data.items : []
                } else {
                    position.servicesData = []
                }
            } catch(err) {
                position.servicesData = []
                this.showError(err)
            }
        },


        addNewSupplier(position) {
            this.position = position
            this.supplier = {}
            this.supplierModal = true
            this.$store.commit('toggleSecondLayer', true)
        },
        closeSupplierModal() {
            this.supplierModal = false
            this.supplier = {}
            this.$store.commit('toggleSecondLayer', false)
        },
        updateSupplier(supplier) {
            if (!supplier) return false
            this.position.selectedSupplier = supplier
            const supplierInList = !!this.suppliersData?.find(i => i.id === supplier.id)
            if (supplier.isNew || !supplierInList) {
                this.suppliersData.push(supplier)
            }
            this.position.suppliersData = this.suppliersData
            this.position.searchData = null
            this.changeSupplier(this.position)
        },
        changeSupplier(position) {
            const newSupplierId = position.selectedSupplier?.id
            position.supplier_id = newSupplierId
            if (!position.isNew) this.checkPositionHasBeenUpdated(position)
        },
        changeAccountingCode(position) {
            const selectedCode = position.selectedAccountingCode?.code
                ?? position.selectedSmartAccountsCode?.code
                ?? null
            position.accounting_code = selectedCode == null ? null : String(selectedCode)
            if (!position.isNew) this.checkPositionHasBeenUpdated(position)
        },
        addNewWarehouseItem(position) {
            if (this.canUseWarehouse === false) return
            if (!position) return
            this.position = position
            this.warehouseItem = {}
            this.warehouseItemModal = true
            this.$store.commit('toggleSecondLayer', true)
        },
        closeWarehouseItemModal() {
            this.warehouseItemModal = false
            this.position = {}
            this.warehouseItem = {}
            this.$store.commit('toggleSecondLayer', false)
        },
        updateWarehouseItem(warehouseItem) {
            if (!warehouseItem || !this.position) return false
            this.position.selectedWarehouseItem = warehouseItem
            if (warehouseItem.isNew && this.warehouseItemsData) {
                this.warehouseItemsData.push(warehouseItem)
            }
            this.position.warehouseItemsData = this.warehouseItemsData
            this.position.searchData = null
            this.changeWarehouseItem(this.position)
        },
        changeWarehouseItem(position) {
            if (this.canUseWarehouse === false) return
            if (position.selectedWarehouseItem) {
                position.is_decimal = position.selectedWarehouseItem.is_decimal && +position.selectedWarehouseItem.is_decimal
                position.qty = position.is_decimal ? this.formatDecimal(position.qty, false) : this.formatDecimal(position.qty, false, 0)
                position.code = position.selectedWarehouseItem.code
                position.raw_code = position.raw_code ? position.raw_code : this.generateRawCode(position.selectedWarehouseItem.code)
                position.name = position.selectedWarehouseItem.name
                position.purchase_price = position.selectedWarehouseItem.purchase_price ? +position.selectedWarehouseItem.purchase_price : 0
                position.sell_price = position.selectedWarehouseItem.sell_price ? +position.selectedWarehouseItem.sell_price : 0
                position.warehouse_item_id = position.selectedWarehouseItem.id
            } else {
                position.is_decimal = false
                position.code = null
                position.name = null
                position.purchase_price = null
                position.sell_price = null
                position.warehouse_item_id = null
            }

            if (!position.isNew) this.checkPositionHasBeenUpdated(position)
            this.calculatePositionSummary(position)
            this.updateMarkup(position)
            // this.updateConsumable()
            this.updateSummary()
        },

        findPositionsLastSortingValue() {
            if (!this.positions?.length) return 1

            const maxSorting = this.positions.reduce((max, position) => {
                const sorting = Number(position?.sorting)

                return Number.isFinite(sorting)
                    ? Math.max(max, sorting)
                    : max
            }, 0)

            return Math.max(maxSorting, this.positions.length) + 1
        },
        addNewPosition(type) {
            if (type === 3 && this.canUseWarehouse === false) return

            if (this.itemData.selectedState?.num && this.itemData.selectedState.num === 12 && type === 2) {
                return
            }

            this.submitted = false
            const position = {
                type: type,
                name: '',
                qty: 1,
                discount: null,
                sum: 0,
                total: 0,
                status: 1,
                isNew: true,
                is_warranty: this.isWarrantyOrder,
                sorting: this.findPositionsLastSortingValue()
            }
            this.applyCustomerDiscountToPosition(position)

            this.pickDefaultTax(position)

            if (type === 2) { //Request
                position.state = 1
            }

            if (type === 1 && this.selectedMasters && this.selectedMasters.length === 1) {
                const master = this.selectedMasters[0];

                if (master) {
                    position.selectedMaster = master;
                    position.positionMasters = [
                        {
                            user_id: +master.id,
                            master,
                            share_percent: 100,
                        },
                    ];
                }
            } else if (type === 1) {
                position.positionMasters = [];
            }

            this.positions.push(position)
        },
        addMaintenancePositions() {
            const positions = [
                {type: 2, name: 'Õlifilter', status: 1,isNew: true,  qty: 1, sum: 0, total: 0},
                {type: 2, name: 'Õhufilter', status: 1, isNew: true, qty: 1, sum: 0, total: 0},
                {type: 2, name: 'Salongifilter', status: 1, isNew: true, qty: 1, sum: 0, total: 0},
                {type: 2, name: 'Kütusefilter', status: 1, isNew: true, qty: 1, sum: 0, total: 0},
                {type: 2, name: 'Mootoriõli 5l', status: 1, isNew: true, qty: 1, sum: 0, total: 0},
                {type: 2, name: 'Mootoriõli 1l', status: 1, isNew: true, qty: 1, sum: 0, total: 0},
            ]

            positions.forEach(position => {
                this.pickDefaultTax(position)

                if (position.type === 2) {
                    position.state = 1
                    position.status = 1
                    position.isNew = true
                    position.sorting = this.findPositionsLastSortingValue()

                    this.applyCustomerDiscountToPosition(position)

                    this.positions.push(position)
                }
            })
        },
        addSecondMaintenancePositions() {
            const positions = [
                {type: 2, name: 'Piduriklotsid ees', qty: 1},
                {type: 2, name: 'Piduriketas ees', qty: 2},
                {type: 2, name: 'Piduriklotsid taga', qty: 1},
                {type: 2, name: 'Piduriketas taga', qty: 2},
            ]

            positions.forEach(position => {
                this.pickDefaultTax(position)

                if (position.type === 2) {
                    position.state = 1
                    position.status = 1
                    position.isNew = true
                    position.sorting = this.findPositionsLastSortingValue()

                    this.applyCustomerDiscountToPosition(position)

                    this.positions.push(position)
                }
            })
        },
        toggleConsumable() {
            this.updateConsumable()
            this.updateSummary()
        },
        updateConsumable() {
            if (!this.useConsumables) {
                this.consumable = null
                return
            }

            if (this.canUseConsumables === false && !this.originalConsumable) {
                this.useConsumables = false
                this.consumable = null
                return
            }

            const positionsWithConsumables = this.positions.filter(
                position => position.type === 1 &&
                    position.status === 1 &&
                    position.selectedService?.consumables_sell &&
                    +position.selectedService.consumables_sell) ?? null


            if (!positionsWithConsumables?.length) {
                this.consumable = null
                return
            }

            if (!this.consumable) {
                this.consumable = {
                    id: null,
                    name: this.$store.getters.locationData?.consumable_name || settings.defaultConsumablesName,
                    qty: 1,
                    discount: null,
                }
                this.pickDefaultTax(this.consumable)
            }

            let consumablesSellPrice = 0
            let positionWithConsumablesQty = 0

            if (positionsWithConsumables && positionsWithConsumables.length) {
                positionWithConsumablesQty += positionsWithConsumables.reduce((sum, position) => {
                    return sum + position.qty
                }, 0)

                consumablesSellPrice += positionsWithConsumables.reduce((sum, position) => {
                    return sum + (position.selectedService.consumables_sell * position.qty)
                }, 0)
            }

            if (this.consumable) {
                if (positionWithConsumablesQty === 0) {
                    this.consumable.qty = 0
                } else {
                    this.consumable.qty = positionWithConsumablesQty < 0 ? -1 : 1
                }
                const consumableSellPrice = consumablesSellPrice * this.consumable.qty
                this.consumable.sell_price = consumableSellPrice || 0

                this.calculatePositionSummary(this.consumable)
            }
        },
        // updateSummary() {
        //     let positionsSum = 0
        //     let positionsTaxSum = 0
        //     let totalTime = 0
        //
        //     const toNum = (v) => Number(String(v ?? 0).replace(',', '.')) || 0
        //
        //     if (this.positions?.length) {
        //         const activePositions = this.positions.filter(p => Number(p.status) === 1)
        //
        //         activePositions.forEach(position => {
        //             const sum = toNum(position.sum)
        //             const taxSum = toNum(position.tax_sum)
        //
        //             positionsSum += sum
        //             positionsTaxSum += taxSum
        //
        //             if (position.type === 1 && position.selectedService?.time) {
        //                 const positionTime = toNum(position.selectedService.time) * toNum(position.qty)
        //                 if (positionTime > 0) totalTime += positionTime
        //             }
        //         })
        //     }
        //
        //     if (this.useConsumables && this.consumable) {
        //         positionsSum += toNum(this.consumable.sum)
        //         positionsTaxSum += toNum(this.consumable.tax_sum)
        //     }
        //
        //     if (this.prepaymentPositions?.length) {
        //         this.prepaymentPositions.forEach(p => {
        //             positionsSum += toNum(p.sum)
        //             positionsTaxSum += toNum(p.tax_sum)
        //         })
        //
        //     }
        //
        //     const grandTotalRaw = positionsSum + positionsTaxSum
        //     const roundedGrandTotal = Math.round(grandTotalRaw * 20) / 20
        //
        //     let adjustment = roundedGrandTotal - grandTotalRaw
        //     if (Object.is(adjustment, -0)) adjustment = 0
        //
        //     this.summary.sum = this.formatDecimal(positionsSum, false)
        //     this.summary.tax = this.formatDecimal(positionsTaxSum, false)
        //     this.summary.grand_total = this.formatDecimal(roundedGrandTotal, false)
        //     this.summary.totalTime = this.formatDecimal(totalTime, false)
        //     this.summary.adjustment = this.formatDecimal(adjustment, false)
        //
        //     // this.syncOrderEndByWorkingHours?.()
        // },

        updateSummary() {
            let positionsSum = 0
            let positionsTaxSum = 0
            let positivePositionsSum = 0
            let positivePositionsTaxSum = 0
            let totalTime = 0

            const toNum = (v) => Number(String(v ?? 0).replace(',', '.')) || 0

            const money = (value) => {
                const rounded = Math.round((Number(value) || 0) * 100) / 100
                return Math.abs(rounded) < 0.005 ? 0 : rounded
            }

            const roundToFiveCents = (value) => {
                return money(Math.round((Number(value) || 0) * 20) / 20)
            }

            if (this.positions?.length) {
                const activePositions = this.positions.filter(p => Number(p.status) === 1)

                activePositions.forEach(position => {
                    const sum = toNum(position.sum)
                    const taxSum = toNum(position.tax_sum)

                    positionsSum += sum
                    positionsTaxSum += taxSum

                    positivePositionsSum += sum
                    positivePositionsTaxSum += taxSum

                    // if (position.type === 1 && position.selectedService?.time) {
                    //     const positionTime = toNum(position.selectedService.time) * toNum(position.qty)
                    //     if (positionTime > 0) totalTime += positionTime
                    // }

                    if (
                        Number(position.type) === 1 &&
                        toNum(position.qty) > 0
                    ) {
                        const positionTime =
                            position.work_time_manual
                                ? Math.max(
                                    0,
                                    toNum(position.work_time)
                                )
                                : Number(
                                    this.getDefaultPositionWorkTime(position) ?? 0
                                )

                        if (positionTime > 0) {
                            totalTime += positionTime
                        }
                    }
                })
            }

            if (this.useConsumables && this.consumable) {
                const sum = toNum(this.consumable.sum)
                const taxSum = toNum(this.consumable.tax_sum)

                positionsSum += sum
                positionsTaxSum += taxSum

                positivePositionsSum += sum
                positivePositionsTaxSum += taxSum
            }

            let prepaymentGrandTotal = 0

            if (this.prepaymentPositions?.length) {
                this.prepaymentPositions.forEach(p => {
                    positionsSum += toNum(p.sum)
                    positionsTaxSum += toNum(p.tax_sum)

                    if (this.isSalesInvoice) {
                        prepaymentGrandTotal += Math.abs(toNum(
                            p.prepayment_invoice_grand_total ??
                            p.prepaymentInvoice?.grand_total ??
                            0
                        ))
                    }
                })
            }

            const grandTotalRaw = money(positionsSum + positionsTaxSum)

            let roundedGrandTotal = roundToFiveCents(grandTotalRaw)

            if (this.isSalesInvoice && prepaymentGrandTotal > 0) {
                const positiveGrandTotal = roundToFiveCents(positivePositionsSum + positivePositionsTaxSum)
                roundedGrandTotal = money(positiveGrandTotal - prepaymentGrandTotal)
            }

            let adjustment = money(roundedGrandTotal - grandTotalRaw)
            if (Object.is(adjustment, -0)) adjustment = 0

            this.summary.sum = this.formatDecimal(positionsSum, false)
            this.summary.tax = this.formatDecimal(positionsTaxSum, false)
            this.summary.grand_total = this.formatDecimal(roundedGrandTotal, false)
            this.summary.totalTime = this.formatDecimal(totalTime, false)
            this.summary.adjustment = this.formatDecimal(adjustment, false)
        },
        changeService(position) {
            const service = position.selectedService

            if (service) {
                const serviceCode = String(service.code ?? '').trim() || null

                position.name = service.name
                position.code = serviceCode
                position.raw_code = serviceCode
                    ? this.generateRawCode(serviceCode)
                    : null

                position.purchase_price = service.purchase
                    ? +service.purchase
                    : null

                position.sell_price = service.sell
                    ? +service.sell
                    : null

                position.service_id = service.id
            } else {
                position.name = null
                position.code = null
                position.raw_code = null
                position.purchase_price = null
                position.sell_price = null
                position.discount = null
                position.service_id = null
            }

            this.checkEmployeePaymentToDelete(position)

            const activeServices = this.positions?.filter(
                position => position.type === 1 && position.status
            )

            if (
                (!this.itemData.name?.length || !this.itemData.has_name)
                && activeServices?.length === 1
            ) {
                this.itemData.name = position.name
            }

            if (!position.isNew) {
                this.checkPositionHasBeenUpdated(position)
            }

            this.calculatePositionSummary(position)
            this.updateConsumable()
            this.updateSummary()
            this.syncOrderEndByWorkingHours?.()
        },

        normalizePositionMastersShares(positionMasters) {
            const rows = Array.isArray(positionMasters)
                ? positionMasters.filter(item => +(item.user_id || item.master?.id || 0) > 0)
                : [];

            if (!rows.length) return [];

            if (rows.length === 1) {
                return [
                    {
                        ...rows[0],
                        share_percent: 100,
                    },
                ];
            }

            const currentSum = rows.reduce((sum, item) => {
                return sum + Number(item.share_percent || 0);
            }, 0);

            if (!currentSum) {
                const base = Math.floor((100 / rows.length) * 100) / 100;
                let total = 0;

                return rows.map((item, index) => {
                    let share = base;

                    if (index === rows.length - 1) {
                        share = +(100 - total).toFixed(2);
                    }

                    total += share;

                    return {
                        ...item,
                        share_percent: share,
                    };
                });
            }

            let total = 0;

            return rows.map((item, index) => {
                let share = +(Number(item.share_percent || 0) / currentSum * 100).toFixed(2);

                if (index === rows.length - 1) {
                    share = +(100 - total).toFixed(2);
                }

                total += share;

                return {
                    ...item,
                    share_percent: share,
                };
            });
        },

        changeSelectedMasters() {
            this.updateMasters = true;

            const servicePositions = this.positions?.filter(pos => pos.status && pos.type === 1);

            if (!servicePositions?.length) return false;

            const selectedMasters = Array.isArray(this.selectedMasters)
                ? this.selectedMasters
                : [];

            const selectedMasterIds = selectedMasters.map(master => +master.id).filter(Boolean);

            servicePositions.forEach(position => {
                if (!selectedMasterIds.length) {
                    position.selectedMaster = null;
                    position.master = null;
                    position.positionMasters = [];

                    this.checkEmployeePaymentToDelete(position);

                    if (!position.isNew) {
                        this.checkPositionHasBeenUpdated(position);
                    }

                    return;
                }

                if (selectedMasterIds.length === 1) {
                    const master = selectedMasters[0];

                    position.selectedMaster = master;
                    position.master = master;
                    position.positionMasters = [
                        {
                            user_id: +master.id,
                            master,
                            share_percent: 100,
                        },
                    ];

                    this.checkEmployeePaymentToDelete(position);

                    if (!position.isNew) {
                        this.checkPositionHasBeenUpdated(position);
                    }

                    return;
                }

                const currentRows = Array.isArray(position.positionMasters)
                    ? position.positionMasters
                    : [];

                let rows = currentRows
                    .map(item => {
                        const userId = +(item.user_id || item.master?.id || 0);

                        if (!userId || !selectedMasterIds.includes(userId)) {
                            return null;
                        }

                        const master = item.master || selectedMasters.find(m => +m.id === userId) || null;

                        return {
                            ...item,
                            user_id: userId,
                            master,
                            share_percent: Number(item.share_percent || 0),
                        };
                    })
                    .filter(Boolean);

                if (!rows.length && position.selectedMaster?.id && selectedMasterIds.includes(+position.selectedMaster.id)) {
                    rows = [
                        {
                            user_id: +position.selectedMaster.id,
                            master: position.selectedMaster,
                            share_percent: 100,
                        },
                    ];
                }

                rows = this.normalizePositionMastersShares(rows);

                position.positionMasters = rows;

                const primary = rows[0] || null;

                position.selectedMaster = primary?.master || null;
                position.master = primary?.master || null;

                this.checkEmployeePaymentToDelete(position);

                if (!position.isNew) {
                    this.checkPositionHasBeenUpdated(position);
                }
            });
        },

        changeMaster(position) {
            if (!this.hasMultiplePositionMasters(position)) {
                position.positionMasters = position.selectedMaster
                    ? [
                        {
                            user_id: +position.selectedMaster.id,
                            master: position.selectedMaster,
                            share_percent: 100,
                        },
                    ]
                    : [];
            }

            position.master = position.selectedMaster || null;

            this.checkEmployeePaymentToDelete(position);

            if (!position.isNew) {
                this.checkPositionHasBeenUpdated(position);
            }
        },
        // checkEmployeePaymentToDelete(position) {
        //     if (!this.isOrderModal) return false
        //     if (position.type !== 1) return false
        //
        //     const paymentIndex = this.paymentsToDeleteIds.indexOf(position.id)
        //
        //     const employeePaymentShouldBeDeleted =
        //         position.originalPositionMastersSignature !== this.getPositionMastersSignature(position.positionMasters) ||
        //         this.formatDecimal(position.originalQty, false) !== this.formatDecimal(position.qty, false) ||
        //         position.originalServiceId !== position.service_id ||
        //         position.originalSellPrice !== position.sell_price
        //
        //     if (employeePaymentShouldBeDeleted) {
        //         const selectedServicePurchase = position.selectedService?.purchase
        //
        //         position.purchase_price = selectedServicePurchase || selectedServicePurchase === 0 || selectedServicePurchase === '0'
        //             ? +selectedServicePurchase
        //             : 0
        //
        //         position.purchase_sum = 0
        //
        //         if (paymentIndex < 0 && position.id) {
        //             this.paymentsToDeleteIds.push(position.id)
        //         }
        //     } else {
        //         position.purchase_price = position.originalPurchasePrice
        //         position.purchase_sum = position.originalPurchaseSum
        //
        //         if (paymentIndex >= 0) {
        //             this.paymentsToDeleteIds.splice(paymentIndex, 1)
        //         }
        //     }
        // },
        checkEmployeePaymentToDelete(position) {
            if (!this.isOrderModal) return false
            if (Number(position.type) !== 1) return false

            const paymentIndex =
                this.paymentsToDeleteIds.indexOf(position.id)

            const toNullableNumber = value => {
                if (
                    value === null ||
                    value === undefined ||
                    value === ''
                ) {
                    return null
                }

                const number = Number(
                    String(value).replace(',', '.')
                )

                return Number.isFinite(number)
                    ? number
                    : null
            }

            const originalWorkTime =
                toNullableNumber(position.originalWorkTime)

            const currentWorkTime =
                position.work_time_manual
                    ? toNullableNumber(position.work_time)
                    : null

            const workTimeChanged =
                originalWorkTime === null ||
                currentWorkTime === null
                    ? originalWorkTime !== currentWorkTime
                    : Math.abs(
                    originalWorkTime - currentWorkTime
                ) > 0.0001

            const employeePaymentShouldBeDeleted =
                position.originalPositionMastersSignature !==
                this.getPositionMastersSignature(
                    position.positionMasters
                ) ||

                this.formatDecimal(
                    position.originalQty,
                    false
                ) !== this.formatDecimal(
                    position.qty,
                    false
                ) ||

                position.originalServiceId !==
                position.service_id ||

                position.originalSellPrice !==
                position.sell_price ||

                workTimeChanged

            if (employeePaymentShouldBeDeleted) {
                const selectedServicePurchase =
                    position.selectedService?.purchase

                position.purchase_price =
                    selectedServicePurchase ||
                    selectedServicePurchase === 0 ||
                    selectedServicePurchase === '0'
                        ? +selectedServicePurchase
                        : 0

                position.purchase_sum = 0

                if (paymentIndex < 0 && position.id) {
                    this.paymentsToDeleteIds.push(position.id)
                }
            } else {
                position.purchase_price =
                    position.originalPurchasePrice

                position.purchase_sum =
                    position.originalPurchaseSum

                if (paymentIndex >= 0) {
                    this.paymentsToDeleteIds.splice(
                        paymentIndex,
                        1
                    )
                }
            }
        },
        updateMarkup(position) {
            if ((position.purchase_price && +position.purchase_price) && (position.sell_price && +position.sell_price)) {
                position.margin = this.calculatePositionMarkup(position)
            } else {
                position.margin = null
            }
        },
        // markupOnInput(position, value) {
        //     if (!position) return
        //     if (value < 0 || value === '-') {
        //         value = 0
        //     }
        //     const discountSumForOneQty = position.discount_sum / position.qty
        //     if (discountSumForOneQty && +discountSumForOneQty) {
        //         return false
        //     } else {
        //         if (position.purchase_price && +position.purchase_price !== 0) {
        //             position.sell_price = position.purchase_price + (position.purchase_price * (value / 100))
        //         } else {
        //             position.sell_price = null
        //         }
        //     }
        //     this.updatePosition(position, value, 'markup')
        // },

        markupOnInput(position, value) {
            if (!position) return

            let markup = this.toNumber(value)

            if (markup < 0) {
                markup = 0
            }

            const qty = this.toNumber(position.qty, 1)
            const discountSumForOneQty = qty
                ? this.toNumber(position.discount_sum) / qty
                : 0

            if (discountSumForOneQty > 0) {
                return false
            }

            const purchasePrice = this.toNumber(position.purchase_price)

            position.margin = markup

            if (purchasePrice > 0) {
                position.sell_price = purchasePrice + (purchasePrice * (markup / 100))
            } else {
                position.sell_price = null
            }

            this.updatePosition(position, markup, 'markup')
        },

        updatePosition(position, value, param, maxValue = null, minValue = null, isEstimate = false) {
            if (value && ((maxValue || maxValue === 0) && value > maxValue)) {
                value = maxValue
            }

            if (value && ((minValue || minValue === 0) && value < minValue)) {
                value = minValue
            }
            if (value && minValue === 0 && value === '-') {
                value = null
            }

            // if (param === 'name') {
            // } else
            if (param === 'code') {
                position.raw_code = this.generateRawCode(position.code)
            } else if (param === 'discount') {
                if (value === '-') {
                    value = 0
                } else if (value > 100) {
                    value = 100
                } else if (value < 0) {
                    value = 0
                }
            } else if (param === 'qty') {
                if (value === '-') {
                    value = null
                }
                if (position.type === 1) { //Service
                    this.checkEmployeePaymentToDelete(position)
                }
            } else if (param === 'purchase_price' && (position.type === 2 || position.type === 4)) {
                const bd = this.$store.getters.locationData
                if (isEstimate) {
                    position.sell_price = computeByContext(
                        value,
                        bd,
                        'estimates',
                        this.$store.getters.canUse('advanced_markup')
                    )
                } else {
                    position.sell_price = computeByContext(
                        value,
                        bd,
                        'orders',
                        this.$store.getters.canUse('advanced_markup')
                    )
                }
            }

            // position[param] = value
            if (param !== 'markup') {
                position[param] = value
            }

            if (!position.isNew) this.checkPositionHasBeenUpdated(position)

            this.calculatePositionSummary(position)

            if (position.type === 1) { //Service
                this.updateConsumable?.()
            }

            if (param !== 'markup') {
                this.updateMarkup(position)
            }
            this.updateSummary()

            if (position.type === 1 && param === 'qty') {
                this.syncOrderEndByWorkingHours?.()
            }
        },

        calculatePositionSummary(position) {
            const qty = Number(position.qty ?? 0)
            const purchasePrice = Number(position.purchase_price ?? 0)
            const sellPrice = Number(position.sell_price ?? 0)
            const discount = Number(position.discount ?? 0)
            const taxValue = Number(position.selectedTax?.value ?? 0)

            const positionPurchaseSum = purchasePrice * qty

            const rawNet = (sellPrice - ((discount / 100) * sellPrice)) * qty

            const net = Number(this.formatDecimal(rawNet, false, 2))

            const tax = Number(this.formatDecimal(rawNet * (taxValue / 100), false, 2))

            const total = Number(this.formatDecimal(net + tax, false, 2))

            const rawDiscountSum = (sellPrice * qty) - rawNet
            const discountSum = Number(this.formatDecimal(rawDiscountSum, false, 2))

            position.purchase_price = (position.purchase_price || position.purchase_price === 0)
                ? this.formatDecimal(position.purchase_price, false, 4)
                : null

            position.sell_price = (position.sell_price || position.sell_price === 0)
                ? this.formatDecimal(position.sell_price, false, 4)
                : null

            position.purchase_sum = positionPurchaseSum
            position.sum = net
            position.tax_sum = tax
            position.discount_sum = discountSum
            position.total = total
        },

        changeTax(position, newTax) {
            position.selectedTax = newTax ?? null
            position.tax_id = newTax?.id ?? null

            const v = newTax?.value
            position.tax_value = (v === 0 || v === '0') ? 0 : (v ? +v : null)

            position.valid_until = newTax?.valid_until ?? null

            const hasPrice = position.sell_price !== null && position.sell_price !== undefined && position.sell_price !== ''
            const hasQty   = position.qty !== null && position.qty !== undefined && position.qty !== ''

            if (hasPrice && hasQty) {
                this.calculatePositionSummary(position)
            }

            if (!position.isNew) {
                this.checkPositionHasBeenUpdated(position)
            } else {
                position._dirty = true
            }

            this.updateSummary()
        },

        removePosition(index, positionType = null) {
            this.positions.splice(index, 1)
            this.updateConsumable()
            this.updateSummary()
            if (positionType && +positionType === 1) this.syncOrderEndByWorkingHours?.()
            // this.checkClearSelectedArea()
        },

        confirmPositionDelete(position) {
            this.positionToDelete = position
            this.confirmPositionDeleteModal = true
            this.$store.commit('toggleSecondLayer', true)
            // this.checkClearSelectedArea()
        },
        closeConfirmPositionDeleteModal() {
            this.positionToDelete = null
            this.confirmPositionDeleteModal = false
            this.$store.commit('toggleSecondLayer', false)
        },
        close() {
            this.hidePositionServiceMetaOverlay()
            this.$emit('close')
        },
    },
    computed: {
        hasPositionMasterSplits() {
            return this.positions?.some(position => {
                const isVisible =
                    position.status ||
                    position.showDeleted ||
                    this.showDeleted

                return (
                    isVisible &&
                    Number(position.type) === 1 &&
                    this.hasMultiplePositionMasters(position)
                )
            }) || false
        },
        closedFinancialPeriodDataEditingDisabled() {
            return this.canUsePeriodLock
                && this.financialPeriodHasBeenClosed
                && !this.closedFinancialDataEditingEnabled
        },
        // thereIsReducedRequest() {
        //     if (!this.positions?.length) return false
        //     if (this.showDeleted) {
        //         return !!this.positions.find(p => p.reduced_qty && +p.reduced_qty && !p.isNew)
        //     } else {
        //         return !!this.positions.find(p => (p.status || p.showDeleted) && p.reduced_qty && +p.reduced_qty && !p.isNew)
        //     }
        // },
        thereIsReducedRequest() {
            return this.positions?.some(position =>
                !position.isNew &&
                (position.status || position.showDeleted || this.showDeleted) &&
                Number(position.reduced_qty) > 0
            ) ?? false
        },
        showRequestStateHeader() {
            if (!this.positions?.length) return false
            if (this.showDeleted) {
                return !!this.positions.find(p => p.type === 2)
            } else {
                return !!this.positions.find(p => p.type === 2 && (p.status || p.showDeleted))
            }
        },
        showHistoryButtonHeader() {
            if (!this.positions?.length) return false
            if (this.showDeleted) {
                return !!this.positions.find(p => p.id)
            } else {
                return !!this.positions.find(p => p.id && (p.status || p.showDeleted))
            }
        },
        showMarginColumn() {
            if (!this.positions?.length) return false
            if (this.showDeleted) {
                return !!(this.positions.find(p => p.type !== 1))
            } else {
                return !!(this.positions.find(p => (p.status || p.showDeleted) && p.type !== 1))
            }
            //Exclude service position
        },
        isAnyPositionWithDiscount() {
            const hasDiscount = (value) => {
                const n = Number(String(value ?? '').replace(',', '.'))
                return Number.isFinite(n) && n !== 0
            }

            const hasPositionDiscount = this.showDeleted
                ? this.positions?.some(p => hasDiscount(p.discount))
                : this.positions?.some(p => hasDiscount(p.discount) && (p.status || p.showDeleted))

            const hasConsumableDiscount = hasDiscount(this.consumable?.discount)

            return !!(hasPositionDiscount || hasConsumableDiscount)
        },
        // isAnyActiveServicePosition() {
        //     return !!this.positions?.find(p => p.status && p.type === 1)
        // },
        showPositionsTable() {
            return (!this.noActivePositions || this.showDeleted) || (this.useConsumables && this.consumable)
        },

        // computedServicesTime() {
        //     if (!this.positions) return 0
        //
        //     const toNum = (v) => Number(String(v ?? 0).replace(',', '.')) || 0
        //
        //     return this.positions
        //         .filter(p => p.status && p.type === 1)
        //         .reduce((total, pos) => {
        //             return total + toNum(pos.selectedService?.time) * toNum(pos.qty)
        //         }, 0)
        // },
        computedServicesTime() {
            return (this.positions || []).reduce(
                (total, position) => {
                    if (
                        Number(position.type) !== 1 ||
                        Number(position.status) !== 1 ||
                        Number(position.qty ?? 0) <= 0
                    ) {
                        return total
                    }

                    const positionTime =
                        position.work_time_manual
                            ? Number(position.work_time ?? 0)
                            : Number(
                                this.getDefaultPositionWorkTime(position) ?? 0
                            )

                    return total + (
                        Number.isFinite(positionTime) &&
                        positionTime > 0
                            ? positionTime
                            : 0
                    )
                },
                0
            )
        },

        serviceMetaEditingIsDisabled() {
            const position = this.serviceMetaPosition

            return !position ||
                Number(position.status) === 0 ||
                this.editingIsDisabled ||
                this.positionsEditingIsDisabled ||
                this.closedFinancialPeriodDataEditingDisabled
        },

        computedDeletedPositionsExists() {
            return !!this.positions?.find(p => !p.status && !p.isRestored && !p.forDeletion && !p.showDeleted)
        },
        noActivePositions() {
            return !this.positions?.find(p => p.status || p.isRestored || p.forDeletion)
        },
        thereIsFixedRequest() {
            if (!this.positions?.length) return false
            if (this.showDeleted) {
                return !!this.positions.find(p => p.fixed_qty && +p.fixed_qty)
            } else {
                return !!this.positions.find(p => p.status && p.fixed_qty && +p.fixed_qty)
            }
        },
    }
}


export default modalWithPositionsMixins
